import { HardCodedSalesItemId, SelectedSalesItemsCar } from 'noddi-types';

type PickupLocation = 'home' | 'otherLocation';

// The reason for this to exist ist that is makes sense to conditionally render salesItem text on this step, based on which items are selected on earlier step.
// This we don't support in salesItem config in admin app, so we just hardcode it here for now.
export const getHardCodedPickupText = (selectedSalesItemsCars: SelectedSalesItemsCar[], location: PickupLocation) => {
  const hasChange = selectedSalesItemsCars.some(
    (car) =>
      car.salesItemId === HardCodedSalesItemId.TireHotelNewCustomerLargeCar ||
      car.salesItemId === HardCodedSalesItemId.TireHotelNewCustomerSmallCar
  );
  const hasOnlyStorage = selectedSalesItemsCars.some(
    (car: SelectedSalesItemsCar) => car.salesItemId === HardCodedSalesItemId.TireHotelNewCustomerOnlyStorage
  );

  if (location === 'otherLocation') {
    if (hasChange) {
      return 'Vi henter dekkene fra ditt nåværende dekkhotell eller en privatadresse, bytter dekk hjemme hos deg og sørger for trygg lagring hos oss etterpå.';
    }
    if (hasOnlyStorage) {
      return 'Vi henter dekkene fra ditt nåværende dekkhotell eller en privatadresse og tar dem trygt med til lagring hos oss.';
    }
    return 'Vi henter dekkene fra ditt nåværende dekkhotell eller en privatadresse – enkelt og greit.';
  }

  if (hasChange) {
    return 'Vi bytter dekk hjemme hos deg og sørger for trygg lagring av de gamle dekkene hos oss etterpå.';
  }
  if (hasOnlyStorage) {
    return 'Vi henter dekkene hjemme hos deg og tar dem trygt med til lagring hos oss.';
  }
  return 'Vi henter dekkene hjemme hos deg – enkelt og greit.';
};
